
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import global from '../../../static/js/global'
export default {
methods:{
confirmCancel(index){
this.showconfirm = true;
this.currentIndex = index;
},
deleteTopic(){
this.$http.get(global.host + "themeShare/deleteTopic?themeId=" + this.currentIndex).then(function(res){
window.location.reload();
},function(err){
console.log(err)
})
},
changeRange(index){
let curr = index;
this.isShow = (index === 1 ? false:true);
this.clearArray(this.list);
this.getData(this.page,++curr);
},
clearArray(arr){
let size = arr.length;
for(let i=0 ; i < size ; i++){
arr.pop();
}
},
getData(page,type,rows=5){
this.$http.post(global.host + 'themeShare/getMyList',{type: type,phone:this.$router.history.current.query.phone,page:page,rows:rows},{header:{Accept: "application/json"}}).then(function(res){
if(res.body.result){
let data = res.body.result;
for(let i = 0; i < data.length ; i++){
data[i].praisePoint = (isNaN(parseInt(data[i].praisePoint))? 0 : parseInt(data[i].praisePoint));
data[i].msgCount = (isNaN(parseInt(data[i].msgCount)) ? 0 : parseInt(data[i].msgCount));
/*判断是否是今天*/
if(dateFormat(new Date(data[i].pushDate),'YYYY-MM-DD') === dateFormat(new Date(),'YYYY-MM-DD')){
data[i].pushDate = '';
}
if(data[i].imgs.length > 0){
for(let j = 0 ; j < data[i].imgs.length; j++){
data[i].imgs[j].maxPicUrl = global.baseImg + data[i].imgs[j].maxPicUrl;
data[i].imgs[j].minPicUrl = global.baseImg + data[i].imgs[j].minPicUrl;
}
}
this.list.push(data[i]);
}
}
console.log(this.list)
},function(err){
console.log(err)
})
}
},
created() {
let self = this;
window.onscroll = function () {
let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
if (scrollTop + windowHeight == scrollHeight) {
if(!self.loading){
self.page += 1;
self.getData(self.page);
}
}
}
},
beforeMount(){
if(this.$router.history.current.path == "/momentsmime"){
document.title = "我的分享";
}
this.getData(this.page,1);
},
components:{Tab, TabItem, XHeader,XImg,Flexbox, FlexboxItem,Confirm,Loading,LoadMore},
filters: {dateFormat },
directives: {TransferDom},
data(){
return{
titles:['我发表的','我参与的'],
list:[],
phone:this.$router.history.current.query.phone,
isShow:true,
width : window.screen.width - 10,
windowWidth:window.screen.width,
currentIndex:0,
showconfirm:false,
page:1,
loading:false,
}
}
}



// WEBPACK FOOTER //
// ./src/components/momentsComponents/mime.vue